import { render } from "./EventTemplatesListTable.vue?vue&type=template&id=5b013e9e"
import script from "./EventTemplatesListTable.vue?vue&type=script&lang=js"
export * from "./EventTemplatesListTable.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src860361777/src/isi_presenter_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__